var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.738 13.946c.318.341.818.334 1.144 0l1.405-1.397c5.161-5.161 7.551-7.496 8.321-6.734.556.556-.913 2.216-3.065 4.749-2.16 2.548-4.66 5.335-2.914 7.098 1.557 1.564 4.01-.453 6.082-2.445 1.755-1.684 2.7-2.557 2.946-2.319.223.222-.238.746-.841 1.795-.755 1.31-1.763 2.921-.723 3.962.802.802 2.104.373 3.676-1.215.382-.381.397-.882.064-1.207-.326-.326-.81-.318-1.143-.008-.906.85-1.446 1.27-1.54 1.183-.104-.095.3-.723.984-1.842 1.151-1.906 1.485-3.002.698-3.788-1.032-1.024-2.612-.246-5.272 2.271-2.231 2.105-3.366 2.859-3.78 2.454-.484-.469.398-1.906 2.986-4.883 3.28-3.78 4.351-5.598 2.986-6.956-1.707-1.7-3.502-.373-10.616 6.741l-1.398 1.398a.805.805 0 000 1.143z",
    fill: "currentColor"
  })));
}

export default SvgDraw;